module.exports = __webpack_public_path__ + "img/18.be8de9f1.png";